<template>
    <div>
        <div class="box">
            <div class="top-bar">
                <b-button @click="$router.go(-1)" class="level-item" type="is-light">
                    <b-icon icon="arrow-left" pack="fas" />
                    <span>Back</span>
                </b-button>
                <p class="sub-title">{{ isEdit ? "Edit" : "New" }} {{ itemName }}</p>
            </div>
            <hr />
            <div class="relative">
                <form @submit.prevent="formSubmit">
                    <b-field label="ID">
                        <b-input disabled v-model="form.id" />
                    </b-field>

                    <b-field
                        label="Category"
                        :message="form.errors.get('category_id')"
                        :type="{ 'is-danger': form.errors.has('category_id') }"
                        expanded
                    >
                        <b-select disabled placeholder="Select" v-model="form.category_id" expanded>
                            <option v-for="(val, idx) in $store.getters.leafCategories" :key="idx" :value="val.id">
                                {{ val.name }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-field
                        label="Filter"
                        v-if="category.category_filters.length"
                        :message="form.errors.get('filter_id')"
                        :type="{ 'is-danger': form.errors.has('filter_id') }"
                        expanded
                    >
                        <b-select placeholder="Select" v-model="form.filter_id" expanded>
                            <option v-for="(val, idx) in category.category_filters" :key="idx" :value="val.id">
                                {{ val.name }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-field
                        v-show="options.showSectionList"
                        label="Section"
                        :message="form.errors.get('section_id')"
                        :type="{ 'is-danger': form.errors.has('section_id') }"
                        expanded
                    >
                        <b-select placeholder="Select" v-model="form.section_id" expanded @input="sectionChanged">
                            <option v-for="(val, idx) in options.sections" :key="idx" :value="val.id">
                                {{ val.name }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-tabs type="is-boxed" expanded :animated="false">
                        <b-tab-item>
                            <template #header>
                                <b-checkbox v-model="en.enable" />
                                <img class="flag" src="/images/uk.png" />
                                <span> English </span>
                            </template>
                            <div class="box" v-show="!en.enable">Language disabled.</div>
                            <template v-if="en.enable">
                                <b-field
                                    :message="form.errors.get(`details.${en.index}.title`)"
                                    :type="{ 'is-danger': form.errors.has(`details.${en.index}.title`) }"
                                    expanded
                                    label="Title English"
                                >
                                    <b-input placeholder="Title English" type="text" v-model="en.title" />
                                </b-field>
                                <b-field expanded label="Post Slug" v-if="en.slug">
                                    <b-input placeholder="Slug" type="text" v-model="en.slug" disabled />
                                </b-field>
                                <b-field
                                    v-if="options.subtitle"
                                    :message="form.errors.get(`details.${en.index}.sub_title`)"
                                    :type="{ 'is-danger': form.errors.has(`details.${en.index}.sub_title`) }"
                                    expanded
                                    :label="options.subtitleToTag ? 'Tag' : 'Subtitle English'"
                                >
                                    <b-input placeholder="Subtitle English" type="text" v-model="en.sub_title" />
                                </b-field>
                                <b-field
                                    v-if="options.location"
                                    :message="form.errors.get(`details.${en.index}.location`)"
                                    :type="{ 'is-danger': form.errors.has(`details.${en.index}.location`) }"
                                    expanded
                                    label="Location English"
                                >
                                    <b-input placeholder="Location English" type="text" v-model="en.location" />
                                </b-field>
                                <b-field
                                    v-if="options.content"
                                    :message="form.errors.get(`details.${en.index}.content`)"
                                    :type="{ 'is-danger': form.errors.has(`details.${en.index}.content`) }"
                                    expanded
                                    label="Description English"
                                >
                                    <!-- <Editor v-model="en.content" /> -->
                                    <jodit-editor v-model="en.content" :buttons="getButtons" :config="getOptions" />
                                    <!-- <b-input placeholder="Description English" type="textarea" v-model="en.content" /> -->
                                </b-field>
                            </template>
                        </b-tab-item>

                        <b-tab-item>
                            <template #header>
                                <b-checkbox v-model="ku.enable" />
                                <img class="flag" src="/images/krd.png" />
                                <span> Kurdish </span>
                            </template>

                            <div class="box" v-show="!ku.enable">Language disabled.</div>
                            <template v-if="ku.enable">
                                <b-field
                                    :message="form.errors.get(`details.${ku.index}.title`)"
                                    :type="{ 'is-danger': form.errors.has(`details.${ku.index}.title`) }"
                                    expanded
                                    label="Title Kurdish"
                                >
                                    <b-input placeholder="Title Kurdish" type="text" v-model="ku.title" />
                                </b-field>
                                <b-field expanded label="Post Slug" v-if="ku.slug">
                                    <b-input placeholder="Slug" type="text" v-model="ku.slug" disabled />
                                </b-field>
                                <b-field
                                    v-if="options.subtitle"
                                    :message="form.errors.get(`details.${ku.index}.sub_title`)"
                                    :type="{ 'is-danger': form.errors.has(`details.${ku.index}.sub_title`) }"
                                    expanded
                                    :label="options.subtitleToTag ? 'Tag' : 'Subtitle Kurdish'"
                                >
                                    <b-input placeholder="Subtitle Kurdish" type="text" v-model="ku.sub_title" />
                                </b-field>
                                <b-field
                                    v-if="options.location"
                                    :message="form.errors.get(`details.${ku.index}.location`)"
                                    :type="{ 'is-danger': form.errors.has(`details.${ku.index}.location`) }"
                                    expanded
                                    label="Location Kurdish"
                                >
                                    <b-input placeholder="Location Kurdish" type="text" v-model="ku.location" />
                                </b-field>
                                <b-field
                                    v-if="options.content"
                                    :message="form.errors.get(`details.${ku.index}.content`)"
                                    :type="{ 'is-danger': form.errors.has(`details.${ku.index}.content`) }"
                                    expanded
                                    label="Description Kurdish"
                                >
                                    <!-- <Editor v-model="ku.content" /> -->
                                    <jodit-editor v-model="ku.content" :buttons="getButtons" :config="getOptions" />
                                    <!-- <b-input placeholder="Description Kurdish" type="textarea" v-model="ku.content" /> -->
                                </b-field>
                            </template>
                        </b-tab-item>
                        <b-tab-item>
                            <template #header>
                                <b-checkbox v-model="ar.enable" />
                                <img class="flag" src="/images/iq.png" />
                                <span> Arabic </span>
                            </template>

                            <div class="box" v-show="!ar.enable">Language disabled.</div>
                            <template v-if="ar.enable">
                                <b-field
                                    :message="form.errors.get(`details.${ar.index}.title`)"
                                    :type="{ 'is-danger': form.errors.has(`details.${ar.index}.title`) }"
                                    expanded
                                    label="Title Arabic"
                                >
                                    <b-input placeholder="Title Arabic" type="text" v-model="ar.title" />
                                </b-field>
                                <b-field expanded label="Post Slug" v-if="ar.slug">
                                    <b-input placeholder="Slug" type="text" v-model="ar.slug" disabled />
                                </b-field>
                                <b-field
                                    v-if="options.subtitle"
                                    :message="form.errors.get(`details.${ar.index}.sub_title`)"
                                    :type="{ 'is-danger': form.errors.has(`details.${ar.index}.sub_title`) }"
                                    expanded
                                    :label="options.subtitleToTag ? 'Tag' : 'Subtitle Arabic'"
                                >
                                    <b-input placeholder="Subtitle Arabic" type="text" v-model="ar.sub_title" />
                                </b-field>
                                <b-field
                                    v-if="options.location"
                                    :message="form.errors.get(`details.${ar.index}.location`)"
                                    :type="{ 'is-danger': form.errors.has(`details.${ar.index}.location`) }"
                                    expanded
                                    label="Location Arabic"
                                >
                                    <b-input placeholder="Location Arabic" type="text" v-model="ar.location" />
                                </b-field>
                                <b-field
                                    v-if="options.content"
                                    :message="form.errors.get(`details.${ar.index}.content`)"
                                    :type="{ 'is-danger': form.errors.has(`details.${ar.index}.content`) }"
                                    expanded
                                    label="Description Arabic"
                                >
                                    <!-- <Editor v-model="ar.content" /> -->
                                    <jodit-editor v-model="ar.content" :buttons="getButtons" :config="getOptions" />
                                    <!-- <b-input placeholder="Description Arabic" type="textarea" v-model="ar.content" /> -->
                                </b-field>
                            </template>
                        </b-tab-item>
                    </b-tabs>

                    <b-field
                        v-if="options.video_url"
                        :message="form.errors.get(`video_url`)"
                        :type="{ 'is-danger': form.errors.has(`video_url`) }"
                        expanded
                        label="Video URL"
                    >
                        <b-input v-model="form.video_url" />
                    </b-field>

                    <b-field
                        v-if="options.time_to_read"
                        :message="form.errors.get(`time_to_read`)"
                        :type="{ 'is-danger': form.errors.has(`time_to_read`) }"
                        expanded
                        label="Time to read the article"
                    >
                        <b-input v-model="form.time_to_read" />
                    </b-field>

                    <b-field
                        v-if="options.has_staff"
                        :message="form.errors.get(`staff_id`)"
                        :type="{ 'is-danger': form.errors.has(`staff_id`) }"
                        expanded
                        label="Staff Writer"
                    >
                        <b-select v-model="form.staff_id" expanded>
                            <option :value="null">Non</option>
                            <option v-for="u in staff" :key="u.value" :value="u.value">{{ u.name }}</option>
                        </b-select>
                    </b-field>

                    <b-field
                        v-if="options.has_contributor"
                        :message="form.errors.get(`contributor_id`)"
                        :type="{ 'is-danger': form.errors.has(`contributor_id`) }"
                        expanded
                        label="Contributor Writer"
                    >
                        <b-select v-model="form.contributor_id" expanded>
                            <option :value="null">Non</option>
                            <option v-for="u in contributors" :key="u.value" :value="u.value">{{ u.name }}</option>
                        </b-select>
                    </b-field>

                    <b-field
                        v-if="options.event_time"
                        :message="form.errors.get(`event_time`)"
                        :type="{ 'is-danger': form.errors.has(`event_time`) }"
                        expanded
                        label="Event Date"
                    >
                        <b-datepicker v-model="form.event_time" inline />
                    </b-field>

                    <b-field
                        v-if="options.expire_date"
                        :message="form.errors.get(`expire_date`)"
                        :type="{ 'is-danger': form.errors.has(`expire_date`) }"
                        expanded
                        label="Expire Date"
                    >
                        <b-datepicker v-model="form.expire_date" inline />
                    </b-field>

                    <b-field
                        v-if="options.internal_external"
                        :message="form.errors.get(`internal_external`)"
                        :type="{ 'is-danger': form.errors.has(`internal_external`) }"
                        expanded
                        label="Workshop Type"
                    >
                        <b-select v-model="form.internal_external" expanded required>
                            <option value="internal">Internal</option>
                            <option value="external">External</option>
                        </b-select>
                    </b-field>

                    <b-field
                        v-if="options.form"
                        :message="form.errors.get(`form_id`)"
                        :type="{ 'is-danger': form.errors.has(`form_id`) }"
                        expanded
                        label="Form Submition"
                    >
                        <b-select v-model="form.form_id" expanded>
                            <option :value="null">Non</option>
                            <option v-for="item in $store.state.forms" :key="item.id" :value="item.id">
                                {{ item.name }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-field label="Archive" v-if="options.show_archive">
                        <b-switch v-model="form.is_archive" :true-value="1" :false-value="0">Archive this post</b-switch>
                    </b-field>

                    <b-field
                        v-if="options.image"
                        :label="options.multi_image ? 'Images' : 'Image'"
                        :message="form.errors.get('image_ids')"
                        :type="{ 'is-danger': form.errors.has('image_ids') }"
                        expanded
                    >
                        <GalleryPicker
                            showFeatured
                            :multiple="options.multi_image"
                            type="image"
                            @select="(id) => (files.image_ids = id)"
                            :initial="files.images"
                            :alwaysArray="true"
                        />
                    </b-field>

                    <b-field
                        v-if="options.document"
                        :label="options.multi_image ? 'Documents' : 'Document'"
                        :message="form.errors.get('document_ids')"
                        :type="{ 'is-danger': form.errors.has('document_ids') }"
                        expanded
                    >
                        <GalleryPicker
                            showFeatured
                            :multiple="options.multi_document"
                            type="document"
                            @select="(ids) => (files.document_ids = ids)"
                            :initial="files.documents"
                            :alwaysArray="true"
                        />
                    </b-field>

                    <b-field
                        v-if="options.podcast"
                        label="Podcast"
                        :message="form.errors.get('podcast_id')"
                        :type="{ 'is-danger': form.errors.has('podcast_id') }"
                        expanded
                    >
                        <GalleryPicker showFeatured type="podcast" @select="(id) => (files.podcast_id = id)" :initial="files.podcast" />
                    </b-field>

                    <div class="bottom-btns">
                        <b-button @click="$router.go(-1)" type="is-light">Cancel</b-button>
                        <b-button :loading="form.busy" native-type="submit" type="is-primary">Submit</b-button>
                    </div>
                </form>
                <b-loading :is-full-page="false" v-model="isLoading"></b-loading>
            </div>
        </div>
    </div>
</template>

<script>
import vform from "../../../plugins/vForm";
import GalleryPicker from "../../../components/Files/GalleryPicker.vue";
// import Editor from "../../../components/Jodit.vue";
import jodit from "./jodit-config";
import "jodit/build/jodit.min.css";
export default {
    components: {
        // Editor,
        GalleryPicker,
    },
    data() {
        return {
            itemName: "Post",
            apiURI: `/posts/${this.$route.params.cat}`,
            isLoading: true,
            options: {
                image: false,
                multi_image: false,
                podcast: false,
                event_time: false,
                document: false,
                multi_document: false,
                expire_date: false,
                location: false,
                showSectionList: true,
                subtitle: false,
                content: true,
                sections: [],
            },
            category: { category_filters: [] },
            en: { title: "", sub_title: "", content: "", location: "", slug: null, enable: true },
            ar: { title: "", sub_title: "", content: "", location: "", slug: null, enable: false },
            ku: { title: "", sub_title: "", content: "", location: "", slug: null, enable: false },
            files: {
                images: [],
                image_ids: [],
                podcast: null,
                podcast_id: null,
                documents: [],
                document_ids: [],
            },
            staff: [],
            contributors: [],
            form: new vform({
                id: "",
                category_id: 0,
                section_id: null,
                filter_id: null,
                details: [],
                file_ids: [],
                type: null,
                expire_date: null,
                event_time: null,
                form_id: null,
                is_archive: 0,
                video_url: null,
                time_to_read: null,
                internal_external: null,
                contributor_id: null,
                staff_id: null,
            }),
        };
    },
    methods: {
        async init() {
            // Category_id
            this.form.category_id = parseInt(this.$route.params.cat);
            let tmp = this.$store.state.categories.find((item) => item.id === this.form.category_id);
            if (tmp) {
                this.category = tmp;
            }

            // Getting staff and contibutors
            let res = await this.$http.get("/staff/list");
            this.staff = res.data;
            res = await this.$http.get("/contributors/list");
            this.contributors = res.data;

            // Loading options
            try {
                let res = await this.$http.get(`${this.apiURI}/options`);
                this.options = { ...this.options, ...res.data };
                if (res.data.section_id) {
                    this.form.section_id = res.data.section_id;
                }
                if (res.data.has_staff) {
                    this.form.contributor_id = null;
                }
                if (res.data.has_contributor) {
                    this.form.staff_id = null;
                }
            } catch (e) {
                this.notify("Error while fetching options", "is-danger");
                return;
            }

            let id = this.$route.params.id;
            // Edit Loading
            if (this.isEdit) {
                // If its not Number
                if (!id || !this.isNumber(id)) {
                    this.notify("Error fetching data.", "is-danger");
                    return;
                }
                try {
                    // Load edit...
                    let res = await this.$http.get(`${this.apiURI}/${id}`);
                    this.form.expire_date = res.data.expire_date ? new Date(res.data.expire_date) : null;
                    this.form.event_time = res.data.event_time ? new Date(res.data.event_time) : null;
                    delete res.data.expire_date;
                    delete res.data.event_time;
                    this.form.fill(res.data);
                    let en = res.data.details.find((item) => item.lang == "en");
                    if (en) {
                        this.en = { ...en, enable: true };
                    } else {
                        this.en.enable = false;
                    }
                    let ar = res.data.details.find((item) => item.lang == "ar");
                    if (ar) {
                        this.ar = { ...ar, enable: true };
                    }
                    let ku = res.data.details.find((item) => item.lang == "ku");
                    if (ku) {
                        this.ku = { ...ku, enable: true };
                    }
                    if (res.data.files) {
                        this.unpackFiles(res.data.files);
                    }
                    if (res.data.image) {
                        this.unpackFiles([res.data.image]);
                    }
                    this.sectionChanged(res.data.section_id);
                } catch (err) {
                    this.notify(err.message, "is-danger");
                    return;
                }
            }
            this.isLoading = false;
        },
        unpackFiles(files) {
            let images = files.filter((item) => item.type == "image");
            let podcast = files.find((item) => item.type == "podcast");
            let documents = files.filter((item) => item.type == "document");
            this.files = {
                ...this.files,
                images,
                image_ids: images.map((item) => item.id),
                podcast,
                podcast_id: podcast?.id,
                documents,
                document_ids: documents.map((item) => item.id),
            };
        },
        packFiles() {
            // let tmp = this.files.image_ids?.concat(this.files.document_ids) ?? [];
            // this.files.podcast_id ? tmp.push(this.files.podcast_id) : undefined;
            // this.form.file_ids = tmp;
            this.form.image_ids = Array.isArray(this.files.image_ids) ? this.files.image_ids : [this.files.image_ids];
            this.form.podcast_id = this.files.podcast_id ? [this.files.podcast_id] : null;
            this.form.document_ids = Array.isArray(this.files.document_ids) ? this.files.document_ids : [this.files.document_ids];
            // console.log("tmp", tmp);
        },
        sectionChanged(section) {
            section = this.options.sections.find((item) => item.id == section);
            if (section == null) {
                return;
            }
            switch (section.type) {
                case "article":
                case "blog":
                case "book":
                    this.options = {
                        ...this.options,
                        image: true,
                        multi_image: true,
                        podcast: false,
                        document: false,
                        multi_document: false,
                        content: true,
                        subtitle: false,
                    };
                    break;
                case "statistic":
                    // TODO
                    break;
                case "reports":
                case "survey":
                case "infograph":
                    this.options = {
                        ...this.options,
                        image: true,
                        multi_image: true,
                        podcast: false,
                        document: true,
                        multi_document: true,
                        content: true,
                        subtitle: false,
                    };
                    break;
                case "podcast":
                    this.options = {
                        ...this.options,
                        image: true,
                        multi_image: false,
                        podcast: true,
                        document: false,
                        multi_document: false,
                        content: true,
                        subtitle: true,
                    };
                    break;
                case "publication":
                    this.options = {
                        ...this.options,
                        image: true,
                        multi_image: false,
                        podcast: false,
                        document: true,
                        multi_document: false,
                        content: false,
                        subtitle: false,
                    };
                    break;
                case "journal":
                    this.options = {
                        ...this.options,
                        image: true,
                        multi_image: true,
                        podcast: false,
                        document: true,
                        multi_document: true,
                        content: true,
                        subtitle: false,
                        video_url: true,
                    };
                    break;
                case "daily-coffe":
                    this.options = {
                        ...this.options,
                        image: false,
                        multi_image: false,
                        podcast: false,
                        document: false,
                        multi_document: false,
                        content: true,
                        subtitle: true,
                        subtitleToTag: true,
                    };
                    break;
                case "video":
                    this.options = {
                        ...this.options,
                        image: true,
                        multi_image: false,
                        podcast: false,
                        document: false,
                        multi_document: false,
                        content: false,
                        subtitle: false,
                    };
                    break;
            }
        },
        // fillInitailFiles(inputFiles) {
        //     this.files.images = inputFiles.filter((item) => item.type == "image");
        //     this.files.podcast = inputFiles.find((item) => item.type == "podcast");
        //     this.files.documents = inputFiles.find((item) => item.type == "document");
        // },
        preprocess() {
            this.packFiles();
            this.form.details = [];
            let i = 0;
            if (this.en.enable) {
                this.form.details.push({ ...this.en, lang: "en" });
                this.en.index = i++;
            }
            if (this.ar.enable) {
                this.form.details.push({ ...this.ar, lang: "ar" });
                this.ar.index = i++;
            }
            if (this.ku.enable) {
                this.form.details.push({ ...this.ku, lang: "ku" });
                this.ku.index = i++;
            }
        },
        formSubmit() {
            this.preprocess();
            if (this.isEdit) {
                // Edit request
                this.form.password = this.form.password == "" ? undefined : this.form.password;
                let update = () => {
                    this.form
                        .submit("post", `${this.apiURI}/${this.form.id}`)
                        .then(() => {
                            //Alert
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: this.itemName + " editied successfully.",
                                type: "is-success",
                            });
                            this.$router.go(-1);
                            // this.$store.dispatch("loadAPI", this.$axios);
                        })
                        .catch((err) => {
                            if (err.response.status != 422) {
                                this.$buefy.toast.open({
                                    duration: 5000,
                                    message: "Something went wrong.",
                                    position: "is-bottom",
                                    type: "is-danger",
                                });
                            }
                        });
                };
                if (this.form.password) {
                    // Password changed, alert for password change
                    this.$buefy.dialog.confirm({
                        title: "Changing password",
                        message: "Are you sure you want to change the <b>password</b> this user? This action cannot be undone.",
                        confirmText: "Confirm",
                        type: "is-warning",
                        hasIcon: true,
                        onConfirm: update,
                    });
                } else {
                    update();
                }
            } else {
                // Create request
                this.form
                    .submit("post", this.apiURI)
                    .then(() => {
                        //Alert
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: this.itemName + " created successfully.",
                            type: "is-success",
                        });
                        this.$router.go(-1);
                        // this.$store.dispatch("loadAPI", this.$axios);
                    })
                    .catch((err) => {
                        if (err.response.status != 422) {
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: "Something went wrong. Please try again.",
                                position: "is-bottom",
                                type: "is-danger",
                            });
                        }
                    });
            }
        },
    },
    // watch: {
    //     "form.section_id": function (val) {
    //         // section changed
    //     },
    // },
    created() {},
    mounted() {
        this.init();
    },
    computed: {
        isEdit() {
            if (this.$route.path.indexOf("new") == -1) {
                return true;
            }
            return false;
        },
        getButtons() {
            return jodit.buttons;
        },
        getOptions() {
            return jodit.options;
        },
    },
};
</script>

<style>
.block {
    display: block;
}
.modal-form {
    position: relative;
}
img.preview-image {
    max-height: 180px;
    border-radius: 10px;
}
</style>
